(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rumoe-model-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rumoe-model-picker')) {
  customElements.define('rumoe-model-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-finish-choice]').forEach(choice => {
        choice.setAttribute('role', 'button');
        choice.setAttribute('aria-pressed', String(choice.classList.contains('is-selected')));
      });
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-finish-choice]');
        if (!choice || !this.contains(choice) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        const panels = [...this.querySelectorAll('[data-finish-panel]')];
        const panel = panels.find(item => item.dataset.finishPanel === choice.dataset.finishChoice);
        if (!panel) return;
        event.preventDefault();
        panels.forEach(item => { item.hidden = item !== panel; });
        this.querySelectorAll('[data-finish-choice]').forEach(item => {
          const selected = item === choice;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
      });
      this.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-finish-choice]')) {
          event.preventDefault();
          event.target.click();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
